<template>
  <div class="wrapper">
    <Sidebar />
    <main class="content">
      <router-view />
    </main>
  </div>
</template> 

<script>
import Sidebar from "@/components/Navigation/Sidebar.vue";
import AuthService from '@/services/auth.service'
import { mapActions } from 'vuex'

export default {
  name: "app",
  components: {
    Sidebar,
  },
  methods: {
    ...mapActions(['login', 'fetchSubscription'])
  },
  async created() {
    if (!AuthService.IsLoggingOutDueToResetPassword) {
      await this.login();
      await this.fetchSubscription();
    }
  },
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap.scss";
@import "~bootstrap-vue/dist/bootstrap-vue.css";
@import "assets/scss/app.scss";
</style>
